export const restaurantObjects = {
  de: {
    name: "Beyeler Restaurant im Park",
    shortDescription:
      "Die spätbarocke Villa Berower liegt im wunderschönen Park der Fondation Beyeler direkt gegenüber dem Museum und beherbergt heute das «Beyeler Restaurant im Park»",
    description:
      "Gerichte aus regionalen und saisonalen Zutaten bilden das Herzstück des kulinarischen Angebots. Die Küche schöpft aus dem Reichtum der Umgebung. Die Menükarte eröffnet den Gästen die Möglichkeit, alte und neue Lieblingsgerichte zu entdecken. Zum Kaffee, der in Barista-Qualität zubereitet wird, steht eine grosse Auswahl an Kuchen bereit. Die Weinkarte orientiert sich an der Umgebung, bietet aber auch eine feine Auswahl aus den restlichen Wein-Regionen der Welt.",
    titleImage: "./images/restaurants/restaurant_im_park.png",
    address: {
      name: "Beyeler Restaurant im Park",
      street: "Baselstrasse 77",
      city: "4125 Riehen/Basel",
      country: "Schweiz",
    },
    openingHours: [
      { day: "Montag bis Sonntag", hours: "10 Uhr bis 18 Uhr" },
      { day: "Mittwochs", hours: "10 Uhr bis 20 Uhr" },
    ],
    phone: "+41 (0)61 645 97 70",
    email: "restaurant@fondationbeyeler.ch",
    menuUrl: "https://restaurant.fondationbeyeler.ch/",
    mapImage: "./images/visits/map.png",
    reservationNotice:
      "Tagsüber können wir leider keine Tische im Restaurant oder auf der Terrasse reservieren. Vielen Dank für Ihr Verständnis. Für die Freitagabende nehmen wir Ihre Reservation sehr gerne entgegen.",
  },
  en: {
    name: "Beyeler Restaurant im Park",
    shortDescription:
      "The late-Baroque Villa Berower is located in the Fondation Beyeler’s magnificent park, straight across from the museum building, and is home to the “Beyeler Restaurant im Park”",
    description:
      "Drawing on the wealth of delicacies to be found nearby, regional and seasonal ingredients are at the heart of the restaurant’s culinary offerings. The menu allows guests to sample old and new favourites. Barista-quality coffee can be enjoyed with a wide choice of cakes. The wine list gives pride of place to regional producers as well as featuring a fine worldwide selection.",
    titleImage: "./images/restaurants/restaurant_im_park.png",
    address: {
      name: "Beyeler Restaurant im Park",
      street: "Baselstrasse 77",
      city: "4125 Riehen/Basel",
      country: "Switzerland",
    },
    openingHours: [
      { day: "Monday to Sunday", hours: "10 a.m. – 6 p.m. *" },
      { day: "Wednesdays", hours: "10 a.m. – 8 p.m." },
    ],
    phone: "+41 (0)61 645 97 70",
    email: "restaurant@fondationbeyeler.ch",
    menuUrl: "https://restaurant.fondationbeyeler.ch/",
    mapImage: "./images/visits/map.png",
    reservationNotice:
      "Unfortunately, we are not able to take daytime bookings for tables in the restaurant or on the terrace. We thank you for your understanding. Bookings are possible for Friday evenings.",
  },
  fr: {
    name: "Beyeler Restaurant im Park",
    shortDescription:
      "La Villa Berower, de style baroque tardif, est située dans le magnifique parc de la Fondation Beyeler directement face au musée et abrite aujourd’hui le « Beyeler Restaurant im Park »",
    description:
      "Puisant parmi les richesses qu’offrent les environs, les ingrédients régionaux et de saison sont au cœur de l’offre culinaire du restaurant. La carte permet aux convives de (re)découvrir des plats favoris établis et inédits. Nos cafés de qualité barista s’accompagnent d’un vaste choix de gâteaux et de pâtisseries. La carte des vins fait la part belle aux crus de la région mais propose également une sélection internationale choisie avec soin.",
    titleImage: "./images/restaurants/restaurant_im_park.png",
    address: {
      name: "Beyeler Restaurant im Park",
      street: "Baselstrasse 77",
      city: "4125 Riehen/ Bâle",
      country: "Suisse",
    },
    openingHours: [
      { day: "Lundi à Dimanche", hours: "10–18 H *" },
      { day: "Mercredi", hours: "10–20 H" },
    ],
    phone: "+41 (0)61 645 97 70",
    email: "restaurant@fondationbeyeler.ch",
    menuUrl: "https://restaurant.fondationbeyeler.ch/",
    mapImage: "./images/visits/map.png",
    reservationNotice:
      "Il nous est malheureusement impossible de réserver des tables dans le restaurant ou sur la terrasse en journée. Merci de votre compréhension. Vos réservations sont les bienvenues pour les vendredi soirs.",
  },
};
